import elrs from "../data/elrs.json";
import utils from "./elrUtils";

/*
 * Gets segment data for a given ELR
 */
const getSegmentForELR = (elr) => {
  for (let i = 0; i < elrs.length; i++) {
    if (elr === elrs[i]["elr"]) {
      return elrs[i];
    }
  }
};

/*
 * Converts a location given in ELR, Miles and Yards into Lat/Lng
 */
const getLatLngFromELR = (elr, miles, yards) => {
  const segment = getSegmentForELR(elr);
  if (!segment) {
    throw new Error("No ELR Found");
  }

  let mileage = utils.getMilesFromMilesAndYards(`${miles}.${yards}`);
  mileage -= utils.getMilesFromMilesAndYards(segment.from);

  if (mileage > 0) {
    let prevPoint, nextPoint, distanceBetweenPoints;

    for (let i = 0; i < segment.points.length - 1; i++) {
      prevPoint = segment.points[i];
      nextPoint = segment.points[i + 1];

      distanceBetweenPoints = utils.calcDistanceBetweenPointsInMiles(prevPoint, nextPoint);

      mileage -= distanceBetweenPoints;

      if (mileage < 0) {
        break;
      }
    }

    if (mileage > 0) {
      // Our best estimation for lat/lng will be that of the point at the end of the segment
      return {
        lat: segment.points[segment.points.length - 1][0],
        lng: segment.points[segment.points.length - 1][1],
      };
    }

    // Calculate the lat/lng by working out the proportion of the partial distance between the
    // two nearest points
    const partialDistance = distanceBetweenPoints + mileage;
    const partialDistanceProportion = partialDistance / distanceBetweenPoints;

    const prevPointLat = parseFloat(prevPoint[0]);
    const prevPointLng = parseFloat(prevPoint[1]);
    const nextPointLat = parseFloat(nextPoint[0]);
    const nextPointLng = parseFloat(nextPoint[1]);
    return {
      lat: (partialDistanceProportion * (nextPointLat - prevPointLat) + prevPointLat).toFixed(6),
      lng: (partialDistanceProportion * (nextPointLng - prevPointLng) + prevPointLng).toFixed(6),
    };
  }

  // Our best estimation for lat/lng will be that of the point at the start of the segment
  return {
    lat: segment.points[0][0],
    lng: segment.points[0][1],
  };
};

export default { getLatLngFromELR };
